<template>
  <div>
    <div class="container">
      <h5 class="vue-title headderFont">
        <strong>{{ $t("USERDETAILS") }}</strong>
      </h5>
      <!-- user details -->
      <p class="userDetails">
        <strong>ユーザー姓名 :</strong>
        {{
          userDetails.last_name +
            " " +
            userDetails.first_name +
            " " +
            (userDetails.gender == "male"
              ? "男性"
              : userDetails.gender == "female"
              ? "女性"
              : "その他") +
            " " +
            age +
            " 歳"
        }}&nbsp;&nbsp;&nbsp;
        <strong>{{ $t("PHONENUMBER") }}:</strong>
        {{ userDetails.contact_no }} &nbsp;&nbsp;&nbsp;
        <strong>{{ $t("EMAIL") }}:</strong>
        {{ userDetails.email }}
      </p>
      <!-- Tabs -->
      <div class="row" v-if="surveyDetails.length">
        <b-tabs content-class="mt-3">
          <!-- Tabs: onclick tab dispay respective survey details -->
          <b-tab
            :title="survey.survey_category.name"
            v-for="survey in surveyDetails"
            :key="survey"
            @click="tabClick()"
          >
            <b-row>
              <!-- Change tab width based on message window -->
              <b-col sm="12" :md="showMessage ? 8 : 12">
                <!-- Table: survey list -->
                <b-table
                  :items="survey.survey_response"
                  :fields="tableHeaders"
                  responsive="sm"
                  class="borderless"
                >
                  <template slot="index" slot-scope="props">
                    {{ survey.survey_response.length + 1 - (props.index + 1) }}
                  </template>

                  <template slot="created_at" slot-scope="row">
                    {{ row.item.created_at | moment("YYYY-MM-DD") }}
                  </template>
                  <template slot="actions" slot-scope="row">
                    <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                    <b-button size="sm" @click.stop="row.toggleDetails">
                      {{ row.detailsShowing ? "Hide" : "Show" }}
                      Details
                    </b-button>
                  </template>
                  <template slot="コメント" slot-scope="row">
                    <em
                      class="fa fa-comment-o openChat"
                      @click="openChat(row.item)"
                      aria-hidden="true"
                    ></em>
                  </template>

                  <template v-slot:cell(show_details)="row">
                    <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                      {{ row.detailsShowing ? "Hide" : "Show" }}
                      Details
                    </b-button>

                    <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
                    <b-form-checkbox
                      v-model="row.detailsShowing"
                      @change="row.toggleDetails"
                      >Details via check</b-form-checkbox
                    >
                  </template>

                  <template v-slot:row-details="row">
                    <b-card class="message-style">
                      <b-row class="mb-12">
                        <b-col>
                          <p class="mandotry-color">診断結果詳細</p>
                        </b-col>
                      </b-row>
                    </b-card>
                  </template>
                </b-table>
              </b-col>
              <!-- Message window -->
              <b-col sm="12" md="4" v-if="showMessage">
                <div class="messageWindowBackground">
                  <div class="container messageWindow">
                    <div class="messaging">
                      <div>
                        <div v-if="selectedSurvey != ''">
                          <b-button
                            v-if="checkPermisssion('PARTNER_USER', false)"
                            size="sm"
                            @click="showChat()"
                            class="mr-2 pull-right"
                            >{{ $t("SENDMESSAGE") }}</b-button
                          >
                        </div>
                        <p>
                          {{ selectedSurvey.created_at | moment("YYYY-MM-DD") }}
                        </p>
                        <div
                          class="msg_history"
                          :key="msg"
                          v-for="msg in surveyMessages"
                        >
                          <div class="incoming_msg">
                            <div class="incoming_msg_img">
                              <img
                                src="../../assets/user-profile.png"
                                alt="sunil"
                                class="ProfileImage"
                              />
                            </div>
                            <div class="received_msg">
                              <div class="received_withd_msg">
                                <p>
                                  <strong>{{ msg.subject }}</strong>
                                </p>
                                <p class="messageSub" v-html="msg.message"></p>
                                <span class="time_date">
                                  {{ getTimeFormet(msg.created_at) }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
      <div class="text-center" v-else>{{ $t("DATANOTFOUND") }}</div>
    </div>
    <!-- Chat modal popup-->
    <b-modal id="chatModal" size="lg" hide-footer>
      <b-form>
        <b-form-group id="addressField" label-for="input-1">
          <span>
            {{ $t("TITLE") }}
            <span class="mandotry-color">*</span>
          </span>
          <b-form-input
            class="inputField"
            id="messageTitle"
            v-model.trim="$v.messageForm.messageTitle.$model"
            type="text"
            autocomplete="off"
          ></b-form-input>
          <show-errors
            :control="$v.messageForm.messageTitle"
            :field="$t('MANDATORY')"
          />
        </b-form-group>
        <br />
        <vue-editor
          v-model="$v.messageForm.content.$model"
          autocomplete="off"
          :editor-toolbar="customToolbar"
        ></vue-editor>
        <show-errors
          :control="$v.messageForm.content"
          :field="$t('MANDATORY')"
        />
      </b-form>
      <br />
      <hr />
      <b-row class="pull-right">
        <b-col>
          <b-button
            variant="outline-primary"
            class="buttons-align-right"
            size="sm"
            @click="submitChat()"
            >送信</b-button
          >
          <b-button
            variant="outline-secondary"
            class="buttons-align-right top-margin"
            size="sm"
            @click="$bvModal.hide('chatModal')"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<style>
.VueTables__child-row-toggler--closed::before {
  content: "+";
}

.VueTables__child-row-toggler--open::before {
  content: "-";
}
</style>
<script>
import { VueEditor } from "vue2-editor";
import ShowErrors from "@/components/ShowErrors";
import { required } from "vuelidate/lib/validators";
import { checkPermisssion } from "@/shared/utils.js";
import moment from "moment-timezone";
import jstz from "jstimezonedetect";
import {
  GET_SERVEY_DETAILS,
  GET_SERVEYMESAGES,
  POST_SERVEYMESAGES
} from "@/store/actions.type";
export default {
  name: "user-details",
  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ] /* displaying only selected features in editor */,
      rowIndex: 0 /* local variable to display countes in each tab. Onclick tab it will reset. */,
      checkPermisssion: checkPermisssion,
      showMessage: false /* to display message div on click on tabs */,
      age: 0 /* Default age field  should be 0 */,
      params: 0 /* Param id */,
      messageForm: {
        messageTitle: "" /* Message title form model */,
        content: "" /*  message body to send message */
      },
      surveyDetails: [] /* Survey table data */,
      surveyMessages: [] /* Survey messages */,
      selectedSurvey: "" /* Selected servey to send message */,
      isLoading: false,
      userDetails: ""
    };
  },
  validations: {
    messageForm: {
      messageTitle: { required },
      content: { required }
    }
  },
  components: { VueEditor, ShowErrors },
  methods: {
    /* when switching tabs need to clear row and messages */
    tabClick() {
      this.showMessage = false;
      this.selectedSurvey = "";
      this.surveyMessages = [];
      this.rowIndex = 0;
    },
    /* onclick show message window. Call get survey message API and bind data */
    async openChat(item) {
      
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
      this.selectedSurvey = item;
      let response = await this.$store.dispatch(GET_SERVEYMESAGES, {
        survey_response_id: this.selectedSurvey.id
      });
      if(!_.get(response, "status", false)){
        this.$toast.error({
          message:  _.get(response, "message", "")
        });
      }else{
        this.showMessage = true;
      }
      this.surveyMessages = _.get(response, "message", "");
      this.isLoading.hide();
    },
    /* onclick send message open chat popup */
    showChat() {
      setTimeout(() => {
        this.$v.messageForm.$reset();
      }, 0);
      this.$bvModal.show("chatModal");
    },
    /* Time formet to current system timezone */
    getTimeFormet(date) {
      var format = "YYYY-MM-DD HH:mm:ss";
      return moment
        .tz(date, format)
        .tz(jstz.determine().name())
        .format(format);
    },
    /* submit message. Save message and bind data */
    async submitChat() {
      this.$v.messageForm.$touch();

      if (!this.$v.messageForm.$invalid) {
        this.$bvModal.hide("chatModal");
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
        let paylod = {
          header: this.messageForm.messageTitle,
          message: this.messageForm.content,
          user_id: this.params.id,
          survey_response_id: this.selectedSurvey.id
        };
        let post_responce  = await this.$store.dispatch(POST_SERVEYMESAGES, paylod);
        if(!_.get(post_responce, "status", false)){
          this.$toast.error({
            message:  _.get(post_responce, "message", "")
          });
        }
        this.isLoading.hide();
        this.messageForm = {
          messageTitle: "",
          content: ""
        };
        let response = await this.$store.dispatch(GET_SERVEYMESAGES, {
          survey_response_id: this.selectedSurvey.id
        });
        this.surveyMessages = _.get(response, "message", "");
      }
    }
  },
  async created() {
    this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
    this.params = this.$route.params;
    let response = await this.$store.dispatch(GET_SERVEY_DETAILS, {
      user_id: this.params.id
    });
    this.isLoading.hide();
    if (_.get(response, "status", false)) {
      this.surveyDetails = response.Surveys;
      this.userDetails = response.user;
      let birthday = new Date(this.userDetails.date_of_birth);
      this.age = Number(
        (new Date().getTime() - birthday.getTime()) / 31536000000
      ).toFixed(0);
    } else {
      this.$toast.error({
        message:  _.get(response, "message", "")
      });
      this.$router.push({
        name: "user"
      });
    }

    this.tableHeaders = [
      { key: "index", label: "回数", sortable: false },
      { key: "created_at", label: "日付", sortable: false },

      { key: "コメント", label: "メッセージ", sortable: false }
    ];
  }
};
</script>
<style>
.container {
  margin: auto;
}
img {
  width: 62px;
  margin-right: 5px;
}
.inbox_people {
  background: #f8f8f8 none repeat scroll 0 0;
  float: left;
  overflow: hidden;
  width: 40%;
  border-right: 1px solid #c4c4c4;
}
.inbox_msg {
  border: 1px solid #c4c4c4;
  clear: both;
  overflow: hidden;
}
.top_spac {
  margin: 20px 0 0;
}

.recent_heading {
  float: left;
  width: 40%;
}
.srch_bar {
  display: inline-block;
  text-align: right;
  width: 100%;
  padding: 0%;
}
.headind_srch {
  padding: 10px 29px 10px 20px;
  overflow: hidden;
  border-bottom: 1px solid #c4c4c4;
}

.recent_heading h4 {
  color: #05728f;
  font-size: 21px;
  margin: auto;
}
.srch_bar input {
  border: 1px solid #cdcdcd;
  border-width: 0 0 1px 0;
  width: 80%;
  padding: 2px 0 4px 6px;
  background: none;
}
.srch_bar .input-group-addon button {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border: medium none;
  padding: 0;
  color: #707070;
  font-size: 18px;
}
.srch_bar .input-group-addon {
  margin: 0 0 0 -27px;
}

.chat_ib h5 {
  font-size: 15px;
  color: #464646;
  margin: 0 0 8px 0;
}
.chat_ib h5 span {
  font-size: 13px;
  float: right;
}
.chat_ib p {
  font-size: 14px;
  color: #989898;
  margin: auto;
}
.chat_img {
  float: left;
  width: 11%;
}
.chat_ib {
  float: left;
  padding: 0 0 0 15px;
  width: 88%;
}

.chat_people {
  overflow: hidden;
  clear: both;
}
.chat_list {
  border-bottom: 1px solid #c4c4c4;
  margin: 0;
  padding: 18px 16px 10px;
}
.inbox_chat {
  height: 550px;
  overflow-y: scroll;
}

.active_chat {
  background: #ebebeb;
}

.incoming_msg_img {
  display: inline-block;
  width: 6%;
}
.received_msg {
  display: inline-block;
  padding: 0 0 0 10px;
  vertical-align: top;
  width: 92%;
  margin-bottom: 21px;
}
.received_withd_msg p {
  background: #fffefe none repeat scroll 0 0;
  border-radius: 3px;
  color: #646464;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 12px;
  width: 104%;
}
.time_date {
  color: #747474;
  display: block;
  font-size: 12px;
  margin: 8px 0 0;
}
.received_withd_msg {
  width: 100%;
}
.messageSub {
  max-height: 400px;
  overflow-y: auto;
}
.mesgs {
  float: left;
  padding: 30px 15px 0 25px;
  width: 60%;
}

.sent_msg p {
  background: #05728f none repeat scroll 0 0;
  border-radius: 3px;
  font-size: 14px;
  margin: 0;
  color: #fff;
  padding: 5px 10px 5px 12px;
  width: 100%;
}
.outgoing_msg {
  overflow: hidden;
  margin: 26px 0 26px;
}
.sent_msg {
  float: right;
  width: 46%;
}
.input_msg_write input {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border: medium none;
  color: #4c4c4c;
  font-size: 15px;
  min-height: 48px;
  width: 100%;
}

.type_msg {
  border-top: 1px solid #c4c4c4;
  position: relative;
}
.msg_send_btn {
  background: #05728f none repeat scroll 0 0;
  border: medium none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 17px;
  height: 33px;
  position: absolute;
  right: 0;
  top: 11px;
  width: 33px;
}
.messaging {
  padding: 20px 0 50px 0;
}
.msg_history {
  /* max-height: 400px;
  overflow-y: auto; */
}
.tabs {
  /* margin: 4em 0; */
  width: 970px;
}

.tabs-component-tabs {
  border: solid 1px #ddd;
  border-radius: 6px;
  margin-bottom: 5px;
}

@media (min-width: 700px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -1px;
  }
}

.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.tabs-component-tab:not(:last-child) {
  border-bottom: dotted 1px #ddd;
}

.tabs-component-tab:hover {
  color: #666;
}

.tabs-component-tab.is-active {
  color: #000;
}

.tabs-component-tab.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

@media (min-width: 700px) {
  .tabs-component-tab {
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 3px 3px 0 0;
    margin-right: 0.5em;
    transform: translateY(2px);
    transition: transform 0.3s ease;
  }

  .tabs-component-tab.is-active {
    border-bottom: solid 1px #fff;
    z-index: 2;
    transform: translateY(0);
  }
}

.tabs-component-tab-a {
  align-items: left;
  color: inherit;
  display: flex;
  padding: 0.75em 1em;
  text-decoration: none;
}
.ProfileImage {
  width: 19px;
  margin-right: 5px;
}

.tabs-component-panels {
  padding: 4em 0;
}
.borderless td,
.borderless th {
  border: none;
}
@media (min-width: 700px) {
  .tabs-component-panels {
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    padding: 4em 2em;
  }
}
.headderFont {
  margin-top: 14px;
}
.userDetails {
  margin-top: 10px;
}
.openChat {
  font-size: 25px;
  cursor: pointer;
}
.messageWindow {
  max-height: 515px;
  overflow: scroll;
}
.messageWindowBackground {
  background: #ededed;
}
.message-style{
  border:1px solid red
}
.top-margin{
  margin-right:10px
}
</style>
